import React from 'react'

// Types
import { LoginProps } from '../types'

// Hooks 
import { useState, useContext } from 'react'

// Context
import { AuthContext } from '../context'
import { useTranslation } from 'react-i18next'

// Styles 
import styles from '../styles/Forms.scss'

// Components 
import { RequiredValidator, EmailValidator } from 'validation'
import { Spinner } from 'spinner'
import { Column, Row } from 'columns'

const Link: React.FC<LoginProps> = (props) => {

  const initialState = {
    username: '',
    password: '',
  }

  const { t } = useTranslation()
  const [ state, setState ] = useState(initialState)
  const { username, password } = state
  const auth = useContext(AuthContext)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget
    setState({ ...state, [name]: value })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    auth.actions.login(username, password)
  }

  if(auth.fetching) return <Spinner />

  return (
    <form onSubmit={handleSubmit}>

      <Row className={styles.formGroup}>
        <Column>
          <label htmlFor="username">{t('login.email')}</label>
          <input 
            name="username" 
            value={username} 
            onChange={handleChange} 
          />
          <EmailValidator className={styles.validationMessage} required={true} value={username}>{t('login.validation.email')}</EmailValidator>
        </Column>

        <Column>
          <label htmlFor="username">{t('login.password')}</label>
          <input 
            type="password" 
            name="password" 
            value={password} 
            onChange={handleChange} 
          />
          <RequiredValidator className={styles.validationMessage} value={password}>{t('login.validation.password')}</RequiredValidator>
        </Column>
      </Row>

      <div className={styles.formGroup}>
        <button>{t('login.loginButton')}</button>
      </div>
    </form>
  )

}

export default Link